import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ITHORPricesAndExchangeRates } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getTSThorPriceConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorswap', 'thor_n_vthor_to_rune', timeframe)) as ITHORPricesAndExchangeRates[]
	const series1 = chartData.map((element: ITHORPricesAndExchangeRates) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VTHOR_RUNE_PRICE }
	})
	const series2 = chartData.map((element: ITHORPricesAndExchangeRates) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.THOR_RUNE_PRICE }
	})
	const series3 = chartData.map((element: ITHORPricesAndExchangeRates) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.EX_RATE }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'vthor/rune',
			type: 'line',
			seriesGroup: '[rune]',
			color: 'green',
			unitSymbol: 'ᚱ'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'thor/rune',
			type: 'line',
			seriesGroup: '[rune]',
			color: 'orange',
			unitSymbol: 'ᚱ'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'vthor/thor',
			type: 'line',
			seriesGroup: '[thor]',
			color: `${color}`,
			unitSymbol: ''
		}
	]

	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const TSThorPrice = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTSThorPriceConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="vTHOR/ᚱUNE"
			chartDesc="Price of THOR and vTHOR relative to RUNE."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="fc5d55ad-e7ff-4614-86b5-eea3a751c33d"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={true}
		/>
	)
}

export default TSThorPrice
